import { createAction, props } from '@ngrx/store';
import { FinanceThreshold } from '../../models/finance-threshold.model';

export const loadFinanceThresholds = createAction('[Finance Thresholds] Load Finance Thresholds');

export const loadFinanceThresholdsSuccess = createAction('[Finance Thresholds] Load Finance Thresholds Success', props<{ thresholds: FinanceThreshold[] }>());

export const loadFinanceThresholdsFailure = createAction('[Finance Thresholds] Load Finance Thresholds Failure', props<{ error: any }>());

export const addFinanceThreshold = createAction('[Finance Thresholds] Add Finance Threshold', props<{ threshold: Partial<FinanceThreshold> }>());

export const addFinanceThresholdSuccess = createAction('[Finance Thresholds] Add Finance Threshold Success', props<{ threshold: FinanceThreshold }>());

export const addFinanceThresholdFailure = createAction('[Finance Thresholds] Add Finance Threshold Failure', props<{ error: any }>());

export const updateFinanceThreshold = createAction('[Finance Thresholds] Update Finance Threshold', props<{ id: number; changes: Partial<FinanceThreshold> }>());

export const updateFinanceThresholdSuccess = createAction('[Finance Thresholds] Update Finance Threshold Success', props<{ threshold: FinanceThreshold }>());

export const updateFinanceThresholdFailure = createAction('[Finance Thresholds] Update Finance Threshold Failure', props<{ error: any }>());

export const deleteFinanceThreshold = createAction('[Finance Thresholds] Delete Finance Threshold', props<{ id: number }>());

export const deleteFinanceThresholdSuccess = createAction('[Finance Thresholds] Delete Finance Threshold Success', props<{ id: number }>());

export const deleteFinanceThresholdFailure = createAction('[Finance Thresholds] Delete Finance Threshold Failure', props<{ error: any }>());
